import { render, staticRenderFns } from "./stock-report.vue?vue&type=template&id=b2a6acd0&scoped=true"
import script from "./stock-report.vue?vue&type=script&lang=js"
export * from "./stock-report.vue?vue&type=script&lang=js"
import style0 from "./stock-report.vue?vue&type=style&index=0&id=b2a6acd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a6acd0",
  null
  
)

export default component.exports